import axios from 'axios';


export const baseURL = '/api_syndrix/v0';

const axiosInstance = axios.create({
    baseURL: baseURL,
});

axiosInstance.interceptors.request.use(function (config: any) {

    type headersTypes = {
        'Content-Type': string,
        'Accept': string,
        'Authorization': string,
        'User': {} | null,
    };

    let headers: headersTypes = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': '',
        'User': {},
    };

    const tokenString = localStorage.getItem('token');
    if (tokenString != null) {

        const userToken = JSON.parse(tokenString);

        if (userToken != null) {
            headers = {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + userToken,
                'User': localStorage.getItem('currentUser'),
            };
        }

    }

    config.headers = headers;

    return config;

}, function (error) {
    return Promise.reject(error);
});

axiosInstance.interceptors.response.use(function (res) {
    return res.data;
}, function (error) {
    if (error.response.status === 401 || error.response.status === 403) {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('token');
        localStorage.removeItem('token_syndrix');
        if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
            window.location.href = '/'
        }

    }

    if (error.response.status === 404) {
        error.response.data = 'Recurso no encontrado.';
    }

    if (error.response.status === 500) {
        error.response.data = 'Error interno';
    }

    return Promise.reject(error);
});

export default axiosInstance;